import { ChangeEvent, Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

import { SearchBar } from 'src/components'
import { IFilter } from 'src/components/filter/types/filter.types'

import { useStyles } from 'src/components/impacts-library/impacts-library-list/styles'

interface IProps {
  filter: IFilter
  setFilter: Dispatch<SetStateAction<IFilter>>
}

const StepsConnectionsFilter = ({ filter, setFilter }: IProps) => {
  const [t] = useTranslation()
  const classes = useStyles()

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value
    setFilter((prev) => ({ ...prev, query }))
  }

  return (
    <div className={classes.filterWrapper}>
      <SearchBar
        search={filter.query}
        handleSearchChange={handleSearchChange}
        inputPlaceholder={t('steps-search-input.v')}
      />
    </div>
  )
}

export { StepsConnectionsFilter }
